import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaymentType } from "../../api/types";
import { MessageResponse } from "../../api/hitl-api";

type ModalsState = {
  payment: {
    open: boolean;
    args?: {
      checkoutId: string | null;
      type: PaymentType | null;
      hasError?: boolean;
      errorStatus?: string;
    } | null;
  };
  instructions: boolean;
  videoPosition: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  messageContent: MessageResponse["result"] | null;
};

const initialState: ModalsState = {
  payment: {
    open: false,
    args: null,
  },
  instructions: false,
  videoPosition: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  },
  messageContent: null,
};

const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    hidePaymentModal(state) {
      state.payment.open = false;
    },
    togglePaymentModal(state, action: PayloadAction<ModalsState["payment"]>) {
      if (state.payment.args === undefined) {
        state.payment.open = action.payload.open;
      } else {
        state.payment = action.payload;
      }
    },
    setPaymentArgs(state, action: PayloadAction<ModalsState["payment"]["args"]>) {
      state.payment.args = action.payload;
    },
    toggleInstructionsModal(state, action: PayloadAction<boolean>) {
      state.instructions = action.payload;
    },
    updateVideoPosition(state, action: PayloadAction<ModalsState["videoPosition"]>) {
      state.videoPosition = action.payload;
    },
    setMessageContent(state, action: PayloadAction<MessageResponse["result"] | null>) {
      state.messageContent = action.payload;
    },
  },
});

export const {
  togglePaymentModal,
  setPaymentArgs,
  updateVideoPosition,
  setMessageContent,
  hidePaymentModal,
} = modalsSlice.actions;

export default modalsSlice.reducer;
